import LoginPage from './loginPage';
import LoginPageEdf from './loginPageEdf';

const routes = [
    {path : 'login', component: () => <LoginPage/>, isPublic : true},
    {path : 'login-sso-edf', component: () => <LoginPageEdf/>, isPublic : true},
]

export default routes;